(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-fbp-gift-media]').forEach(function (card) {
      if (card.dataset.fbpGiftObserved) return;
      card.dataset.fbpGiftObserved = '1';
      function load() {
        card.querySelectorAll('img[data-fbp-gift-src]').forEach(function (img) {
          img.src = img.getAttribute('data-fbp-gift-src');
          img.removeAttribute('data-fbp-gift-src');
        });
      }
      if (!('IntersectionObserver' in window)) { load(); return; }
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          load();
          observer.disconnect();
        }
      }, { rootMargin: '0px' });
      observer.observe(card);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
